import { useMemo, useReducer } from 'react';
import type { FunctionComponent, ReactNode } from 'react';

import CropOrdersContext from './CropOrdersContext';
import { getActions } from './actions';
import { initialState, reducer } from './reducer';

const CropOrdersProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const actions = useMemo(() => getActions(dispatch), [dispatch]);

  return (
    <CropOrdersContext.Provider value={{ actions, state }}>{children}</CropOrdersContext.Provider>
  );
};

export default CropOrdersProvider;
